/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResponsibilityClaimsCreateRequest } from '../../models/responsibility-claims-create-request';
import { ResponsibilityClaimsListResponse } from '../../models/responsibility-claims-list-response';

export interface CreateResponsibilityClaims$Params {
      body: ResponsibilityClaimsCreateRequest
}

export function createResponsibilityClaims(http: HttpClient, rootUrl: string, params: CreateResponsibilityClaims$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponsibilityClaimsListResponse>> {
  const rb = new RequestBuilder(rootUrl, createResponsibilityClaims.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponsibilityClaimsListResponse>;
    })
  );
}

createResponsibilityClaims.PATH = '/api/v1/responsibility_claims';
